import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Card, CardContent } from "../components/ui/card";
import { Clock, ArrowLeft, ShieldCheck } from "lucide-react";
import BRAND from "../brand";

export default function PendingApprovalPage() {
  return (
    <div className="min-h-screen bg-[#F8FAFC] flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <div className="flex flex-col items-center mb-8">
          <img
            src={BRAND.logoUrl}
            alt="Revyniqx"
            className="h-10 w-auto mb-3"
            onError={(e) => { e.target.style.display = "none"; }}
          />
          <h1 className="text-xl font-bold text-[#0B1F3B]">{BRAND.productName}</h1>
        </div>

        <Card className="shadow-xl border-slate-200/60 rounded-2xl" data-testid="pending-approval-card">
          <CardContent className="pt-8 pb-8">
            <div className="text-center space-y-6">
              <div className="w-20 h-20 bg-amber-50 rounded-full flex items-center justify-center mx-auto">
                <Clock className="w-10 h-10 text-amber-500" />
              </div>

              <div className="space-y-2">
                <h2 className="text-2xl font-bold text-[#0B1F3B]" data-testid="pending-title">
                  Approval Pending
                </h2>
                <p className="text-sm text-slate-500 max-w-xs mx-auto leading-relaxed">
                  Your account is awaiting admin approval. You will be able to access the platform once an administrator reviews and approves your request.
                </p>
              </div>

              <div className="flex items-center gap-3 p-4 bg-slate-50 rounded-xl text-left">
                <ShieldCheck className="w-5 h-5 text-slate-400 flex-shrink-0" />
                <p className="text-xs text-slate-500">
                  This is a controlled-access platform. All new accounts require administrator approval before activation.
                </p>
              </div>

              <Link to="/login">
                <Button
                  variant="outline"
                  className="w-full h-11 rounded-xl mt-2"
                  data-testid="back-to-login-btn"
                >
                  <ArrowLeft className="w-4 h-4 mr-2" />
                  Back to Sign In
                </Button>
              </Link>
            </div>
          </CardContent>
        </Card>

        <p className="text-center text-xs text-slate-400 mt-6">{BRAND.poweredBy}</p>
      </div>
    </div>
  );
}
